import { render, staticRenderFns } from "./issuable_bulk_edit_sidebar.vue?vue&type=template&id=6e4dcddf&"
import script from "./issuable_bulk_edit_sidebar.vue?vue&type=script&lang=js&"
export * from "./issuable_bulk_edit_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports